<template>
    <div>
        <label class="relative flex items-center text-muted-500 text-md lg:text-lg font-bold">Language:
            <select v-model="locale" class="inline-block focus:outline-none bg-transparent text-muted-500 font-bold cursor-pointer appearance-none pl-2">
                    <option v-for="(label, locale) in languages"
                            :key="locale"
                            :value="locale"
                    >{{ label }}</option>
            </select>
            <div class="pointer-events-none flex items-center text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
        </label>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                languages: {
                    'en': 'En',
                    'es': 'Es'
                },
                locale: localStorage.locale || 'en'
            }
        },
        watch: {
            locale() {
                localStorage.locale = this.locale;
                window.location.reload();
            }
        }
    }
</script>

